import React, { useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import Swal from "sweetalert2";
import { verifyotp } from "../components/Apis";
import { useNavigate } from "react-router";

const Otpverify = ({ otp }) => {
  
  console.log("otp varityyyyyyy",otp)
  const [inputOtp, setInputOtp] = useState(otp || ""); // القيمة الافتراضية هي otp
  console.log("inputOtp",inputOtp)
  const navigate = useNavigate();

  const handleOtpChange = (e) => {
    setInputOtp(e.target.value);
  };

  const handleCreateAccount = () => {
    window.location.href = '/'; // استبدل بالمسار المناسب لصفحة إنشاء الحساب
  };

  const handleVerify = async () => {
    if (inputOtp === otp) {
      const res = await verifyotp(inputOtp)
      console.log(res)
      if (res.success) {
        Swal.fire("Success", "OTP Verified Successfully!", "success");

        handleCreateAccount()
      }
      else if (res.response.data.success === false) {
        Swal.fire({
          icon: "error", // لتحديد رمز الخطأ
          title: "Error",
          text: res.response.data.message || "An error occurred.",
          confirmButtonText: "OK",
        });
      }
      // تنفيذ أي إجراء إضافي بعد التحقق
    } else {
      Swal.fire("Error", "Invalid OTP. Please try again.", "error");
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 400, mx: "auto" }} dir="ltr">
      <Typography variant="h6" gutterBottom>
        Verify OTP
      </Typography>
      <TextField
        label="Enter OTP"
        value={otp}
        onChange={handleOtpChange}
        fullWidth
        required
      />
      <Box sx={{ mt: 2, textAlign: "center" }}>
        <Button
          variant="contained"
          onClick={handleVerify}
          sx={{
            backgroundColor: "#C47D60",
            "&:hover": { backgroundColor: "#a86850" },
          }}
        >
          Verify
        </Button>
      </Box>
    </Box>
  );
};

export default Otpverify;
